import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { RecommendationService } from '../../../../core/services/recommendation.service';
import { FuseNavigationService } from '../../../../core/components/navigation/navigation.service';

@Component({
  selector: 'recommendation-elearning',
  templateUrl: './recommendation-elearnings.component.html',
  styleUrls: ['./recommendation-elearnings.component.scss'],
  standalone: false,
  animations: fuseAnimations
})

export class RecommendationElearningsComponent implements OnInit {
  currentIndex = 0;
  elearnings: any = [];
  loading = true;
  constructor(private recommendationService: RecommendationService, private navigationService: FuseNavigationService) {
  }

  ngOnInit() {
    this.getRecommendationElearnings();
    const elearningNavItem = this.navigationService.getNavigationItem('recommendation.recommendation-elearning');
    if (elearningNavItem?.badge)  {
      const recommendationNavItem = this.navigationService.getNavigationItem('recommendation');
      if (recommendationNavItem.badge) recommendationNavItem.badge = recommendationNavItem.badge - elearningNavItem.badge;
      elearningNavItem.badge = 0;
    }
  }

  getRecommendationElearnings(): void {
    this.recommendationService.recommendations('elearning').subscribe((elearnings: any) => {
      this.recommendationService.favoriteRecommendation().subscribe((favorEvent: any) => {
        if (elearnings){
          for (let i = 0; i < favorEvent.length; i++) {
            let index = elearnings.findIndex(elern => +elern.id === +favorEvent[i].recommendationId);
            if (index > -1) {
              elearnings[index].isFavorite = true;
              elearnings[index].favId = favorEvent[i].id;
            }
          }
          this.elearnings = elearnings;
        }
        this.loading = false;
      });
    })
  }

  scrollCarousel(direction) {
    const carousel = document.getElementById('carousel');
    const cards = carousel.children;
    const total = cards.length;

    this.currentIndex += direction;

    if (this.currentIndex < 0) this.currentIndex = 0;
    if (this.currentIndex >= total) this.currentIndex = total - 1;

    const offset = -this.currentIndex * 100;
    carousel.style.transform = `translateX(${offset}%)`;
  }

  deleteElearnings(index: number) {
    this.elearnings.splice(index, 1);
    if (this.currentIndex > 0) this.scrollCarousel(-1);
  }
}
